import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'getUnmatchedCount',
    standalone: false
})
export class GetUnmatchedCountPipe implements PipeTransform {
    transform(matched: number, listSize: number): number {
        let contactsUnMatched = listSize - matched;
        if (contactsUnMatched < 0) {
            contactsUnMatched = 0;
        }
        return Number(contactsUnMatched);
    }

}
